import type { IBaseComponentProps } from 'components/base/types'
import { Grid } from 'components/grid'
import { clip } from '@/utils/string'
import { EAssetType, type FindexInvestment, type FullInvestment } from 'findef'
import { tv } from 'tailwind-variants'
import { computed, defineComponent } from 'vue'
import { AssetImageV2 } from 'components/asset-image-v2'
import { prettyAssetType } from '@/utils/asset'

const clazz = tv({
  slots: {
    base: 'cursor-pointer hover:opacity-80',
    iconWrapper:
      'w-10 h-10 bg-gray-100 text-gray-400 flex items-center content-center justify-center overflow-hidden',
    title: 'text-gray-900',
    subtitle: 'text-gray-500'
  },
  variants: {
    size: {
      s: {
        iconWrapper: 'w-5 h-5',
        title: 'text-xs',
        subtitle: 'text-xs'
      },
      xs: {
        iconWrapper: 'w-2 h-2'
      }
    }
  }
})

type IInvestmentDisplayProps = IBaseComponentProps & {
  investment: FindexInvestment | FullInvestment
  size?: 'xs' | 's' | 'm' | 'l'
  withName?: boolean;
  iconColor?: string;
  iconClass?: string;
  showSubtype?: boolean;
}
export const InvestmentDisplay = defineComponent<IInvestmentDisplayProps>(
  (props) => {
    const inv = computed(() => props.investment)
    const asset = computed(() => inv.value.asset)
    const classes = clazz({ size: props.size as any })
    const layout = computed(() => (props.withName === false ? 'max-content' : 'max-content auto'))
    return () => {
      return (
        <Grid class={classes.base({})} columns={layout.value} alignItems="center" gap="0.5rem">
          <div class={classes.iconWrapper({})}>
            <AssetImageV2
              size="full"
              variant="gray"
              investment={inv.value}
              asset={asset.value}
              iconProps={{
                size: [EAssetType.CRYPTO, EAssetType.COMMODITY].includes(asset.value.type as EAssetType) ? '0.86rem' : '1rem',
                ...(props.iconColor ? { fill: props.iconColor } : {}),
              }}
            />
          </div>
          {props.withName !== false && (
            <Grid noDefaultLayout rows={props.showSubtype === false ? 'max-content' : 'max-content max-content'}>
              <div class={classes.title({})}>{clip(asset.value.name, 32)}</div>
              {props.showSubtype !== false && <div class={classes.subtitle({})}>
                {prettyAssetType(
                  asset.value.type || EAssetType.UNDEFINED,
                  asset.value.listed,
                  asset.value.subtypes,
                  false,
                  true
                )}
              </div> }
            </Grid>
          )}
        </Grid>
      )
    }
  },
  { props: ['investment', 'size', 'withName', 'iconColor', 'iconClass', 'showSubtype'] }
)
